import React, { Fragment, ReactNode } from "react";
import { Stack } from "@storyofams/react-ui";
import { FormattedMessage, defineMessages } from "react-intl";
import { Heading, Text } from "../../../components";

const messages = defineMessages({
  instructions: "Gebruiksaanwijzing",
  warnings: "Waarschuwingen",
});

export const Title = ({ children }: { children: ReactNode }) => (
  <Heading variant="h3" as="h3" css={{ textTransform: "initial" }}>
    {children}
  </Heading>
);

export const Instructions = ({ getValue }) => {
  const warnings = getValue("waarschuwingen");
  const instructions = getValue("gebruiksaanwijzing");
  const durability = getValue("houdbaarheid");

  return (
    <Stack flexDirection="column" space={2} mt={[2, 0]}>
      {instructions && (
        <>
          <Title>
            <FormattedMessage {...messages.instructions} />
          </Title>

          <Text>{instructions}</Text>
        </>
      )}

      {warnings && (
        <>
          <Title>
            <FormattedMessage {...messages.warnings} />
          </Title>

          <Text>{warnings}</Text>
        </>
      )}
      {durability && (
        <>
          <Title>Houdbaarheid</Title>

          <Text>{durability} maanden</Text>
        </>
      )}
    </Stack>
  );
};
